import { RootState } from '../store'

export const selectFav = (state: RootState) => state.favorites
